import { useState, useEffect, useCallback } from "react";
import { getSystemSettings, updateSystemSettings } from "@/services/supabaseService";
import type { SystemSettings } from "@/lib/supabase";

export default function useStoreSettings() {
  const [settings, setSettings] = useState<SystemSettings>({
    id: 1,
    site_line_url: "https://line.me/ti/p/-xtd_8xuUf",
    bank_name: "台灣銀行",
    account_name: "吉時國際貿易股份有限公司",
    account_number: "012-1234-5678-9012",
    bank_branch: "台北信義分行",
    recharge_note: "轉帳完成後請記得填寫後五碼並上傳憑證",
    updated_at: new Date().toISOString(),
  });
  const [isLoading, setIsLoading] = useState(true);

  const fetchSettings = useCallback(async () => {
    try {
      const data = await getSystemSettings();
      if (data) setSettings(data);
    } catch {
      // fallback: keep default
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSettings();
  }, [fetchSettings]);

  const updateSetting = async (key: keyof SystemSettings, value: string) => {
    const updates: Partial<SystemSettings> = { [key]: value };
    try {
      const updated = await updateSystemSettings(updates);
      setSettings(updated);
    } catch {
      // silently fail
    }
  };

  return {
    lineUrl: settings.site_line_url,
    settings,
    isLoading,
    updateSetting,
    refresh: fetchSettings,
  };
}